var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownicon = function SvgChevronDownicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.177 7.113a.25.25 0 0 1 0-.353l.583-.583a.25.25 0 0 1 .353 0L8 9.063l2.887-2.886a.25.25 0 0 1 .353 0l.583.583a.25.25 0 0 1 0 .353L8.177 10.76a.25.25 0 0 1-.354 0L4.177 7.113Z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDownicon;